<div class="layout-row layout-align-start-center full-height">
  <bz-icon class="margin-right-5 primary-300" [icon]="icons.packages"></bz-icon>
  <span class="br-body-1">{{ (totals().packages === 1 ? 'X_PACKAGE' : 'X_PACKAGES') | translate: {sum: totals().packages} }}</span>

  <bz-icon class="margin-left-10 margin-right-5 primary-300" [icon]="icons.spots"></bz-icon>
  <span class="br-body-1">{{ (totals().spots === 1 ? 'X_SPOT' : 'X_SPOTS') | translate: {sum: totals().spots} }}</span>

  <bz-icon class="margin-left-10 margin-right-5 primary-300" [icon]="icons.weight"></bz-icon>
  <span class="br-body-1">{{ (totals().weight || 0) | number }} {{ weightUnit | translate }}</span>

  <bz-icon class="margin-left-10 margin-right-5 primary-300" [icon]="icons.volume"></bz-icon>
  <span class="br-body-1">{{ (totals().volume || 0) | number }} {{ volumeUnit | translate }}</span>
</div>
